import React from 'react';
import { motion } from 'framer-motion';
const projects = [{
  id: 1,
  title: 'Modern Kitchen Remodel',
  category: 'Kitchen Remodel',
  image: 'https://cdn.magicpatterns.com/uploads/sYtHCXoyLuY9pR3sfzQGTa/lotus-design-n-print-oCw5_evbWyI-unsplash.jpg',
  description: 'Complete tear-down and rebuild with custom cabinetry and quartz countertops.'
}, {
  id: 2,
  title: 'Exterior Refresh',
  category: 'Exterior Painting',
  image: 'https://cdn.magicpatterns.com/uploads/6YWKju3vmyd6BvooUYuRk1/pixasquare-4ojhpgKpS68-unsplash.jpg',
  description: 'Full exterior painting including trim, siding, and brick limewashing.'
}, {
  id: 3,
  title: 'Master Bath Oasis',
  category: 'Bathroom Renovation',
  image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80&w=800',
  description: 'Luxury walk-in shower, double vanity, and premium tile installation.'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-20 md:py-32 bg-warmGray" data-id="element-123">
      <div className="container mx-auto px-4 md:px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-charcoal tracking-tight mb-4" data-id="element-126">
            See the Difference
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto rounded-full mb-6" data-id="element-127" />
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto" data-id="element-128">
            Browse our recent projects and discover the quality of our
            craftsmanship.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-129">
          {projects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col" data-id="element-130">
              <div className="relative h-64 overflow-hidden" data-id="element-131">
                <div className="absolute inset-0 bg-charcoal/20 group-hover:bg-transparent transition-colors z-10" data-id="element-132" />
                <img src={project.image} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-133" />
                <div className="absolute top-4 left-4 z-20 bg-white/90 backdrop-blur-sm px-3 py-1 rounded text-xs font-semibold text-charcoal uppercase tracking-wider" data-id="element-134">
                  {project.category}
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-135">
                <h3 className="font-heading text-xl font-bold text-charcoal mb-2" data-id="element-136">
                  {project.title}
                </h3>
                <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-137">
                  {project.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-138">
          <a href="#portfolio" className="inline-block bg-gold text-white px-8 py-4 rounded font-semibold text-base md:text-lg hover:bg-gold/90 transition-colors shadow-md" data-id="element-139">
            View Full Portfolio
          </a>
        </div>
      </div>
    </section>;
}